import Bowser from "bowser";

function GetOs(): Bowser.Parser.OSDetails {
    const operatingSystem = Bowser.getParser(window.navigator.userAgent);
    let operatingSystemDetails = operatingSystem.getOS() || { name: "Unknown", version: "Unknown" };
    
    // If it's Windows, add custom logic for specific Windows versions
    if (operatingSystemDetails.name === "Windows") {
        const windowsDetails = checkWindowsVersion();
        // Only assign the object if checkWindowsVersion returns an object
        if (typeof windowsDetails === 'object') {
            operatingSystemDetails = windowsDetails;
        }
    }
    
    return operatingSystemDetails;
}

/**
 * Windows OS version detection. Windows 11 acts in an odd way so we need to
 * check the userAgent directly and not rely on Bowser.
 *
 * @returns {{name: string, version: string} | string}
 */
function checkWindowsVersion(): { name: string, version: string } | string {
    const userAgent = navigator.userAgent;
    
    // Check for Windows 11
    if (userAgent.includes("Windows NT 10.0; Win64; x64")) {
        return { name: 'Windows', version: '11' };
    }
    
    // Check for Windows 10
    if (userAgent.includes("Windows NT 10.0")) {
        return { name: 'Windows', version: '10' };
    }
    
    // Check for Windows 8.1
    if (userAgent.includes("Windows NT 6.3")) {
        return { name: 'Windows', version: '8.1' };
    }
    
    // Check for Windows 8
    if (userAgent.includes("Windows NT 6.2")) {
        return { name: 'Windows', version: '8' };
    }
    
    // Check for Windows 7
    if (userAgent.includes("Windows NT 6.1")) {
        return { name: 'Windows', version: '7' };
    }
    
    // Check for Windows Vista
    if (userAgent.includes("Windows NT 6.0")) {
        return { name: 'Windows', version: 'Vista' };
    }
    
    // Check for Windows XP
    if (userAgent.includes("Windows NT 5.1") || userAgent.includes("Windows XP")) {
        return { name: 'Windows', version: 'XP' };
    }
    
    // If no specific version is detected, return the OS name
    if (userAgent.includes("Windows")) {
        return "Windows";
    }
    
    return "Unknown";
}

function Os() {
    const osDetails = GetOs();
    
    return (
        <div className="information_card">
            <h3>Operating system</h3>
            <p
                className="information"
                data-os-name={osDetails.name}
                data-os-version-name={osDetails.version} // Removed `versionName`
                data-os-version-no={osDetails.version}
            >
                {osDetails.name} - {osDetails.version}
            </p>
        </div>
    );
}

export default Os;
